import type { RosterTab, ShiftTemplate, TimeEntry } from "@pentacode/core";
import { TimeEntryType, toTimeString } from "@pentacode/core";
import { app } from "../../../init";

export function calculateFrequentTimes(
    timeEntries: TimeEntry[],
    previousTimeEntries: TimeEntry[],
    activeTab: RosterTab | undefined
): ShiftTemplate[] {
    const templates = new Map<string, ShiftTemplate>(
        app.shiftTemplates.map(({ venue, start, end, positionId }) => [
            `${venue}-${positionId}-${start?.slice(0, 5)}-${end?.slice(0, 5)}`,
            {
                venue,
                start,
                end,
                uses: Infinity,
                positionId,
                favorite: true,
            },
        ])
    );

    const time = activeTab?.time;
    const departments = activeTab?.departments;

    for (const a of [...timeEntries, ...previousTimeEntries].filter(
        (a) =>
            a.type === TimeEntryType.Work &&
            !a.deleted &&
            !app.isRemoved(a) &&
            a.planned &&
            a.position &&
            (!departments || departments.includes(a.position.departmentId)) &&
            (!time || a.matchesTimeFilter(time))
    )) {
        const { venue, department } = app.getDepartment(a.position!.departmentId);
        if (!venue || !department || !app.hasAccess({ department })) {
            continue;
        }

        const start = toTimeString(a.startPlanned || a.startFinal);
        const end = toTimeString(a.endPlanned || a.endFinal);

        if (!start || !end) {
            continue;
        }

        const key = `${venue.id}-${a.position!.id}-${start}-${end}`;

        if (!templates.has(key)) {
            templates.set(key, { venue: venue.id, start, end, uses: 0, positionId: a.position!.id });
        }

        templates.get(key)!.uses!++;
    }

    return [...templates.values()].sort(({ uses: n1 }, { uses: n2 }) => n2! - n1!);
}
